import React, { useState, useContext } from 'react';
import { AuthContext } from '../../../contexts/auth/authContext';
import { Alert, Button, Modal, Row, Col } from 'react-bootstrap';
import { DonorId } from '../authComponents';
import { ModalPageNames } from 'app/consts';

function DonorIdEmailVerification({
  onClose,
  setPageName,
  emailToBeVerified,
}) {
  const { handleUnverifiedEmail } = useContext(AuthContext);
  const [donorId, setDonorId] = useState('');
  const [donorIdIsValid] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const verifyDonorIdForEmail = async (): Promise<void> => {
    try {
      await handleUnverifiedEmail(emailToBeVerified, donorId);
      setPageName(ModalPageNames.VERIFYING_ACCOUNT);
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <>
      <Modal.Header>
        <Modal.Title>Verify Donor ID</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <p className="text-center mb-4">
          Your account ({emailToBeVerified}) needs to complete the verification process.  
          Please provide your unique Donor ID to have a verification code delivered to the email address on file.
        </p>
          
        <DonorId
          donorId={donorId}
          donorIdIsValid={donorIdIsValid}
          setDonorId={setDonorId}
        />

        <Row className="mt-3">
          <Col>
            <Button 
              variant="danger"
              onClick={onClose}
              className="w-100"
            >
              Cancel
            </Button>
          </Col>
          <Col>
            <Button 
              variant="danger"
              onClick={verifyDonorIdForEmail}
              className="w-100"
            >
              Verify Donor ID
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </>
  );
};

export default DonorIdEmailVerification;